/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Toast_StartInputs */



/**
* | output |
* | --- |
* | "Dialogue List Export" |
*
* @param {Dialogue_List_Export_Toast_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_toast_start = /** @type {((inputs?: Dialogue_List_Export_Toast_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Toast_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation de la liste des dialogues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialoglistenexport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione elenco dialoghi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт списка диалогов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de lista de diálogos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对话列表导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダイアログリストのエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद सूची निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar lista de diálogos")
	return /** @type {LocalizedString} */ ("Dialogue List Export")
});